import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const highlightTotalSavingsBasketSelector = createSelector(testTargetOffersSelector, offers => offers.highlightTotalSavingsBasket || Empty.Object);

export { highlightTotalSavingsBasketSelector };
